export default __webpack_public_path__ + "static/media/user-1.5758cce6.png";